/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description homeAnswersUsingGet参数
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamshomeAnswersUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * list
 */
export type ParamsBodyhomeArticleBannerUsingPost = Array<models.BannerVO>;
/**
 * @description homeArticleFollowUsingGet参数
 * @property `[classifyId]` 分类id 获取全部传0
 * @property `[lastMark]` 上页最后一个的标记
 * @property `pageSize` 每页条数
 */
export interface ParamshomeArticleFollowUsingGet {
  // queryParams
  /**
   * 分类id 获取全部传0
   */
  classifyId?: number;
  /**
   * 上页最后一个的标记
   */
  lastMark?: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description homeArticlesNewUsingGet参数
 * @property `[lastMark]` 上页最后一个的标记
 * @property `pageSize` 每页条数
 * @property `[type]` 最热类型/最新类型 最热->HOT 最新->LATEST
 */
export interface ParamshomeArticlesNewUsingGet {
  // queryParams
  /**
   * 上页最后一个的标记
   */
  lastMark?: number;
  /**
   * 每页条数
   */
  pageSize: number;
  /**
   * 最热类型/最新类型 最热->HOT 最新->LATEST
   */
  type?: string;
}
/**
 * @description homeArticlesUsingGet参数
 * @property `[classifyId]` 分类id 获取全部传0
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 * @property `[type]` 最热类型/最新类型 最热->HOT 最新->LATEST
 */
export interface ParamshomeArticlesUsingGet {
  // queryParams
  /**
   * 分类id 获取全部传0
   */
  classifyId?: number;
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
  /**
   * 最热类型/最新类型 最热->HOT 最新->LATEST
   */
  type?: string;
}
/**
 * @description homeBannerUsingGet参数
 * @property `[type]` tab类型： 1文章 2问答
 */
export interface ParamshomeBannerUsingGet {
  // queryParams
  /**
   * tab类型： 1文章 2问答
   */
  type?: number;
}
/**
 * @description homeFollowUsingGet参数
 * @property `[classifyId]` 分类id 获取全部传0
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamshomeFollowUsingGet {
  // queryParams
  /**
   * 分类id 获取全部传0
   */
  classifyId?: number;
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description homeHotGroupsUsingGet参数
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamshomeHotGroupsUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description homeHotTeamsUsingGet参数
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamshomeHotTeamsUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * list
 */
export type ParamsBodyhomeQuestionBannerUsingPost = Array<models.BannerVO>;
/**
 * @description homeQuestionFollowerUsingGet参数
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamshomeQuestionFollowerUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description homeQuestionsUsingGet参数
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 * @property `[type]` 最热类型/最新类型 最热->HOT 最新->LATEST
 */
export interface ParamshomeQuestionsUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
  /**
   * 最热类型/最新类型 最热->HOT 最新->LATEST
   */
  type?: string;
}
/**
 * @description homeSendRobotMessageUsingGet参数
 * @property `id` id
 * @property `name` 中文名
 * @property `title` title
 * @property `type` type
 */
export interface ParamshomeSendRobotMessageUsingGet {
  // queryParams
  /**
   * id
   */
  id: string;
  /**
   * 中文名
   */
  name: string;
  /**
   * title
   */
  title: string;
  /**
   * type
   */
  type: number;
}
export class HomeApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 获取最新回答列表
   * @param params ParamshomeAnswersUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultAnswerSimpleInfo
   */
  public homeAnswersUsingGet = (
    params: ParamshomeAnswersUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultAnswerSimpleInfo> => {
    const path = '/api/home/answers';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 添加banner文章
   
   * @param data: ParamsBodyhomeArticleBannerUsingPost// list
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public homeArticleBannerUsingPost = (
    data: ParamsBodyhomeArticleBannerUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/home/article/banner';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.list');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取关注文章列表(通过上页最后一个的标记)
   * @param params ParamshomeArticleFollowUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultfollowActionInfo
   */
  public homeArticleFollowUsingGet = (
    params: ParamshomeArticleFollowUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultfollowActionInfo> => {
    const path = '/api/home/article/follow';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('classifyId' in params) p.query.classifyId = params.classifyId;
    if ('lastMark' in params) p.query.lastMark = params.lastMark;
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取首页最新/最热文章列表(根据上页最后一个的标记)
   * @param params ParamshomeArticlesNewUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultArticleHotVO
   */
  public homeArticlesNewUsingGet = (
    params: ParamshomeArticlesNewUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultArticleHotVO> => {
    const path = '/api/home/articles/new';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('lastMark' in params) p.query.lastMark = params.lastMark;
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('type' in params) p.query.type = params.type;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取首页未读最新文章数量
   
   
   * @param opt ajax config
   * @returns models.CommonResultint
   */
  public homeArticlesUnreadCountUsingGet = (
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultint> => {
    const path = '/api/home/articles/unreadCount';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取首页最新/最热文章列表
   * @param params ParamshomeArticlesUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultArticleHotVO
   */
  public homeArticlesUsingGet = (
    params: ParamshomeArticlesUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultArticleHotVO> => {
    const path = '/api/home/articles';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('classifyId' in params) p.query.classifyId = params.classifyId;
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('type' in params) p.query.type = params.type;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取首页推荐列表
   * @param params ParamshomeBannerUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultListBannerVO
   */
  public homeBannerUsingGet = (
    params: ParamshomeBannerUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListBannerVO> => {
    const path = '/api/home/banner';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('type' in params) p.query.type = params.type;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 数据修复
   
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public homeDataFixUsingGet = (opt?: ExtraFetchParams): AjaxPromise<models.CommonResult> => {
    const path = '/api/home/data-fix';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取关注文章列表
   * @param params ParamshomeFollowUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultfollowActionInfo
   */
  public homeFollowUsingGet = (
    params: ParamshomeFollowUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultfollowActionInfo> => {
    const path = '/api/home/follow';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('classifyId' in params) p.query.classifyId = params.classifyId;
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 发送感谢推送
   
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public homeGanxieUsingGet = (opt?: ExtraFetchParams): AjaxPromise<models.CommonResult> => {
    const path = '/api/home/ganxie';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 发送感谢推送
   
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public homeGanxietomyselfUsingGet = (
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/home/ganxietomyself';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取热门圈子
   * @param params ParamshomeHotGroupsUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultListHotGroupOrTeamEntity
   */
  public homeHotGroupsUsingGet = (
    params: ParamshomeHotGroupsUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListHotGroupOrTeamEntity> => {
    const path = '/api/home/hot/groups';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取热门团队
   * @param params ParamshomeHotTeamsUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultListHotGroupOrTeamEntity
   */
  public homeHotTeamsUsingGet = (
    params: ParamshomeHotTeamsUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListHotGroupOrTeamEntity> => {
    const path = '/api/home/hot/teams';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取热门的圈子和团队
   
   
   * @param opt ajax config
   * @returns models.CommonResultGroupOrTeam
   */
  public homeHotUsingGet = (
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultGroupOrTeam> => {
    const path = '/api/home/hot';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 添加banner文章
   
   * @param data: ParamsBodyhomeQuestionBannerUsingPost// list
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public homeQuestionBannerUsingPost = (
    data: ParamsBodyhomeQuestionBannerUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/home/question/banner';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.list');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取关注问答列表
   * @param params ParamshomeQuestionFollowerUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultFollowQuestionOrAnswerInfo
   */
  public homeQuestionFollowerUsingGet = (
    params: ParamshomeQuestionFollowerUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultFollowQuestionOrAnswerInfo> => {
    const path = '/api/home/question/follower';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取最新/最热提问列表
   * @param params ParamshomeQuestionsUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultQuestionSimpleInfo
   */
  public homeQuestionsUsingGet = (
    params: ParamshomeQuestionsUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultQuestionSimpleInfo> => {
    const path = '/api/home/questions';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('type' in params) p.query.type = params.type;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 发送机器人消息
   * @param params ParamshomeSendRobotMessageUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public homeSendRobotMessageUsingGet = (
    params: ParamshomeSendRobotMessageUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/home/sendRobotMessage';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('id' in params) p.query.id = params.id;
    ajax.check(params.id, 'id');
    if ('name' in params) p.query.name = params.name;
    ajax.check(params.name, 'name');
    if ('title' in params) p.query.title = params.title;
    ajax.check(params.title, 'title');
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new HomeApi();
